import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import {find, forEach, get, indexOf, map, size, sortBy, values} from 'lodash';
import {useState} from 'react';

import HaplotypeFrequencyTable from 'components/HaplotypeFrequencyTable';
import FactSection from 'components/shared/fact_section';

import './FrequencySection.scss';


const tabLabels = {
  AOU: 'All of Us',
  UKBB: 'UK Biobank',
  CPIC: 'CPIC',
};

export function HaplotypeFrequencySection({frequency, alleleName}) {
  // default to the first source that has data
  const [freqSource, setFreqSource] = useState(
    find(sortBy(values(frequency), (o) => get(o, 'frequencies.0.dataSource', '')), (f) => size(f.frequencies) > 0)?.typeKey || Object.keys(tabLabels)[0],
  );
  return (
    <FactSection title="Frequencies">
      <nav className="nav nav-tabs" role="tablist">
        {map(Object.keys(tabLabels), (tabLabel) => {
          const active = tabLabel === freqSource;
          const hasData = size(frequency[tabLabel]?.frequencies) > 0;
          const dataIcon = hasData ? <span className="hapFreqNav__dot"><FontAwesomeIcon icon="circle" title="Has data available" /></span> : null;
          return (
            <a
              key={tabLabel}
              href="#"
              role="tab"
              aria-selected={active}
              className={clsx('nav-item', 'nav-link', {active}, {'text-muted': !hasData})}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setFreqSource(tabLabel);
              }}
            >
              {tabLabels[tabLabel]} {dataIcon}
            </a>
          );
        })}
      </nav>
      <HaplotypeFrequencyTable alleleName={alleleName} data={frequency[freqSource]} source={freqSource} />
    </FactSection>
  );
}

// frequencies should show in this preferred order, set by curators
const frequencySourceOrder = Object.keys(tabLabels);
// we want to order by the above source list BUT list frequencies with data first
export function compareFrequency(a, b) {
  if (!a) return 1;
  if (!b) return -1;

  const aHasData = Object.prototype.hasOwnProperty.call(a, 'frequencies');
  const bHasData = Object.prototype.hasOwnProperty.call(b, 'frequencies');

  // sort things with data first
  if (aHasData && !bHasData) return -1;
  if (!aHasData && bHasData) return 1;

  return indexOf(frequencySourceOrder, a.typeKey) - indexOf(frequencySourceOrder, b.typeKey);
}

export function sortAndLabelFrequencies(frequencyObj = {}) {
  const newFrequencyObj = {};
  forEach(Object.keys(frequencyObj), (key) => {
    const frequency = frequencyObj[key];
    frequency.typeKey = key;
    frequency.label = tabLabels[key];
    newFrequencyObj[key] = frequency;
  });
  return newFrequencyObj;
}
